export default __webpack_public_path__ + "static/media/regulatory--end-of-snow-chains--g2.7382850a.png";